import type { AreaConfig } from "./config";

export function buildFAQJsonLd(area: AreaConfig) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: area.faq.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}
